import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./infopelanggan.css";

// Jumlah instance InfoBackground yang sedang mounted (bisa >1 sesaat saat
// transisi antar halaman InfoPelanggan). Kelas body hanya dilepas ketika
// instance terakhir unmount, supaya tidak "kedip" saat transisi.
let ipBgActiveCount = 0;

function InfoBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    ipBgActiveCount += 1;
    document.body.classList.add("ip-bg-active");

    const canvas = canvasRef.current;
    if (!canvas) {
      return () => {
        ipBgActiveCount = Math.max(0, ipBgActiveCount - 1);
        if (ipBgActiveCount === 0) {
          document.body.classList.remove("ip-bg-active");
        }
      };
    }

    const ctx = canvas.getContext("2d");
    const reduce =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let W = 0;
    let H = 0;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let pts = [];
    let raf = null;
    let resizeTimer = null;
    const COLOR = "59,151,245"; // #3B97F5 (biru air referensi)

    const count = () => Math.min(90, Math.round((W * H) / 22000));

    const init = () => {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W * DPR;
      canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      const n = count();
      pts = [];
      for (let i = 0; i < n; i++) {
        pts.push({
          x: Math.random() * W,
          y: Math.random() * H,
          vx: (Math.random() - 0.5) * 0.28,
          vy: (Math.random() - 0.5) * 0.28,
          r: 1.1 + Math.random() * 1.6,
        });
      }
    };

    const frame = () => {
      ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < pts.length; i++) {
        const p = pts[i];
        if (!reduce) {
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < 0 || p.x > W) p.vx *= -1;
          if (p.y < 0 || p.y > H) p.vy *= -1;
        }
        for (let j = i + 1; j < pts.length; j++) {
          const q = pts[j];
          const dx = p.x - q.x;
          const dy = p.y - q.y;
          const d = Math.sqrt(dx * dx + dy * dy);
          if (d < 136) {
            ctx.strokeStyle = `rgba(${COLOR},${(0.42 * (1 - d / 136)).toFixed(3)})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.stroke();
          }
        }
      }
      for (let k = 0; k < pts.length; k++) {
        const pt = pts[k];
        ctx.fillStyle = `rgba(${COLOR},0.7)`;
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, pt.r, 0, Math.PI * 2);
        ctx.fill();
      }
      if (!reduce) raf = requestAnimationFrame(frame);
    };

    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        init();
        if (reduce) {
          ctx.clearRect(0, 0, W, H);
          frame();
        }
      }, 180);
    };

    const onVisibilityChange = () => {
      if (document.hidden) {
        if (raf) cancelAnimationFrame(raf);
      } else if (!reduce) {
        raf = requestAnimationFrame(frame);
      }
    };

    init();
    frame();
    window.addEventListener("resize", onResize, { passive: true });
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      if (raf) cancelAnimationFrame(raf);
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", onResize);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      ipBgActiveCount = Math.max(0, ipBgActiveCount - 1);
      if (ipBgActiveCount === 0) {
        document.body.classList.remove("ip-bg-active");
      }
    };
  }, []);

  return ReactDOM.createPortal(
    <div className="ip-refbg" aria-hidden="true">
      <div className="grid"></div>
      <div className="wave-mid"></div>
      <span className="glow g1"></span>
      <span className="glow g2"></span>
      <span className="glow g3"></span>
      <span className="glow g4"></span>
      <canvas ref={canvasRef}></canvas>
    </div>,
    document.body,
  );
}

export default InfoBackground;
